import React, { useEffect, useState } from 'react';
import { closePopupIcon } from '../assets/superAdminAssets';
import DataTable from '../components/DataTable';
import { useAppContext } from '../contexts/AppContext';
import { Constants } from '../constants';
import moment from 'moment';
import { getCompanyAdminHistory } from '../services/company.service';

const CompanyAdminHistory = ({ show, onClose, companyId = '0', showAdminHistoryModalAnimation, companyName = '' }) => {
  const { showLoader, hideLoader, showToaster, hideToaster, isLoading } = useAppContext();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchText, setSearchText] = useState('');
  const [totalCount, setTotalCount] = useState(0);
  const [adminHistoryData, setAdminHistoryData] = useState([]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      fetchAdminHistory(page, rowsPerPage, searchText);
    }, 500);
    return () => clearTimeout(timeout);
  }, [page, rowsPerPage, searchText]);

  useEffect(() => {
    setPage(1);
  }, [searchText]);

  async function fetchAdminHistory(pageIndex, pageSize, search) {
    try {
      showLoader();
      const res = await getCompanyAdminHistory({
        Id: companyId,
        PageIndex: pageIndex,
        PageSize: pageSize,
        SearchText: search || '',
      });
      if (res?.status === 200) {
        let data = [];
        if (res.resultObject) {
          const parsed = typeof res.resultObject === 'string' && res.resultObject !== '' ? JSON.parse(res.resultObject) : res.resultObject;
          data = Array.isArray(parsed) ? parsed : [];
          setTotalCount(Number(res.message?.split(' ')[1]) || data.length);
        } else {
          setTotalCount(0);
        }
        setAdminHistoryData(data);
      } else {
        showToaster(res.message, 'error');
        setTimeout(() => {
          hideToaster();
        }, Constants.TOASTERHIDETIME);
      }
    } catch (error) {
      console.log(error);
      showToaster('Failed to fetch admin history', 'error');
      setTimeout(() => {
        hideToaster();
      }, Constants.TOASTERHIDETIME);
    } finally {
      hideLoader();
    }
  }

  if (!show) return null;

  return (
    <>
      <div
        className={`modal-backdrop fade ${showAdminHistoryModalAnimation ? 'show' : ''}`}
        onClick={() => onClose()}
        style={{ zIndex: 1040 }}
      ></div>
      <div
        className={`modal fade-right d-block drawer-modal transactions-drawer custom-full-width-drawer-size ${showAdminHistoryModalAnimation ? 'show' : ''}`}
        id="transactionsModal"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="transactionsModalLabel"
        style={{ zIndex: 1050 }}
        onClick={(e) => {
          // Close modal when clicking outside the modal-content
          if (e.target === e.currentTarget) {
            onClose();
          }
        }}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="drawer-head d-flex justify-content-between">
              <div>
                <h3>{companyName || 'Loan Mantra'}</h3>
                <span className="lm-text-light">Admin History</span>
              </div>
              <button type="button" className="close border-none" data-dismiss="modal" aria-label="Close" onClick={() => onClose()}>
                <span aria-hidden="true"><img src={closePopupIcon} alt="" /></span>
              </button>
            </div>
            <div className="drawer-body">
              <div className="application-detail">
                <div className="p-3">
                  <DataTable
                    isLoading={isLoading}
                    tableId="adminHistoryTable"
                    className="mt-0"
                    columns={[
                      {
                        key: 'PreviousAdminName',
                        label: 'Previous Admin Name',
                        sortable: true,
                        render: (value) => (
                          value || '-'
                        ),
                      },
                      {
                        key: 'PreviousAdminEmail',
                        label: 'Previous Admin Email',
                        sortable: true,
                        render: (value) => (
                          value || '-'
                        ),
                      },
                      {
                        key: 'NewAdminName',
                        label: 'New Admin Name',
                        sortable: true,
                        render: (value) => (
                          value || '-'
                        ),
                      },
                      {
                        key: 'NewAdminEmail',
                        label: 'New Admin Email',
                        sortable: true,
                        render: (value) => (
                          value || '-'
                        ),
                      },
                      {
                        key: 'ChangedDate',
                        label: 'Changed Date',
                        sortable: true,
                        render: (value) => (
                          value ? moment.utc(value).local().format('MMM DD, YYYY hh:mm A') : '-'
                        ),
                      },
                    ]}
                    data={adminHistoryData}
                    defaultRowsPerPage={10}
                    totalCount={totalCount}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    onPageChange={setPage}
                    onRowsPerPageChange={(val) => { setRowsPerPage(val); setPage(1); }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CompanyAdminHistory;
